import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IHistogeneticsDetailReportResponse } from "@nkr/store/index";
import HistogeneticslReportList from "./histogenetics-trans-detail-list";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getHistogeneticsReport: (startDate: string, endDate: string) => Promise<IHistogeneticsDetailReportResponse>,
    getHistogeneticsExport: (startDate: string, endDate: string, reportId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
}

class HistogeneticsTransactionReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <>
                <HistogeneticslReportList
                    getHistogeneticsReport={this.props.getHistogeneticsReport}
                    getHistogeneticsExport={this.props.getHistogeneticsExport}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getHistogeneticsReport: (startDate, endDate) => {
            return dispatch(ReportActionCreators.getHistogeneticsReport(startDate, endDate));
        },
        getHistogeneticsExport: (invoiceYear, invoiceMonth, reportId) => {
            return dispatch(ReportActionCreators.getHistogeneticsExport(invoiceYear, invoiceMonth, reportId));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(HistogeneticsTransactionReport);